import { observable, action, makeObservable, computed } from 'mobx';

export interface NoteAuth {
  appkey: string;
  nonce: string;
  checksum: string;
  curTime: string;
  whiteboardChannelId: string;
  locale: string;
}

export enum MemberDeviceType {
  window = 0,
  ipad = 1,
  android = 2,
  ipone = 3,
  mac = 4,
  linux = 6,
  web = 9,
}

export enum NotePermission {
  ALL = 1,
  ONLY_SCREEN = 2,
}
class Note {
  constructor() {
    makeObservable(this);
  }

  @observable shareAnnotateEnabled = false; //共享批注是否开启
  @observable shareAnnotatePermission = NotePermission.ALL; //共享批注权限 参考枚举 ShareAnnotatePermission
  @observable memberDeviceType = MemberDeviceType.web; //参会设备类型

  @observable shareMemberUid = ''; //开启（关闭）批注时，正在共享的用户 uid
  @observable shareMemberDeviceId = false; //开启（关闭）批注时，正在共享的参会设备 ID
  @observable originWidth = 0; //开启（关闭）批注时，共享屏幕的原始宽度
  @observable originHeight = 0; //开启（关闭）批注时，共享屏幕的原始高度

  @observable shareAnnotateWbYxAuth: NoteAuth = {
    appkey: '',
    nonce: '',
    checksum: '',
    curTime: '',
    whiteboardChannelId: '',
    locale: '',
  };

  @observable isWebOpenNote = false; //是否打开了 Web 端的白板

  @computed
  get isPCShareAnnotate() {
    return [MemberDeviceType.mac, MemberDeviceType.window].includes(this.memberDeviceType);
  }

  @action setIsWebOpenNote = (value: boolean) => {
    this.isWebOpenNote = value;
  };

  @action setShareAnnotateEnabled = (value: boolean) => {
    this.shareAnnotateEnabled = value;
  };

  @action setShareAnnotatePermission = (value: NotePermission) => {
    this.shareAnnotatePermission = value;
  };

  @action setShareMemberDeviceType = (value: MemberDeviceType) => {
    this.memberDeviceType = value;
  };

  @action setShareAnnotateAuth = (data: NoteAuth) => {
    this.shareAnnotateWbYxAuth = data;
  };

  @action setOriginSize(width: number, height: number) {
    this.originWidth = width;
    this.originHeight = height;
  }

  @action clearShareAnnotateWbYxAuth = () => {
    this.shareAnnotateWbYxAuth = {
      appkey: '',
      nonce: '',
      checksum: '',
      curTime: '',
      whiteboardChannelId: '',
      locale: '',
    };
  };
}

export default Note;
